import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { authAPI } from '../services/api';

// ── AUTH STORE ──────────────────────────────────────────────────────────────
export const useAuthStore = create(
  persist(
    (set, get) => ({
      user: null,
      token: null,
      role: 'sender', // 'sender' | 'admin'
      impersonating: null,
      adminToken: null,
    
    login: async (email, password) => {
        const res = await authAPI.login(email, password);
        if (res.data.requires_2fa) {
          return { requires2FA: true, tempToken: res.data.temp_token, method: res.data.two_fa_method };
        }
        const { access_token, role, user_id } = res.data;
        localStorage.setItem('token', access_token);
        set({ token: access_token, role, user: { id: user_id, email, role } });
        return { requires2FA: false, role };
      },

      impersonate: async (userId) => {
        const api = (await import('../services/api')).default;
        const res = await api.post('/api/v1/admin/impersonate/' + userId);
        const { access_token, user } = res.data;
        const currentToken = get().token;
        localStorage.setItem('admin_token', currentToken);
        localStorage.setItem('token', access_token);
        set({
          token: access_token,
          user: { ...user },
          role: user.role,
          impersonating: { email: user.email, full_name: user.full_name },
          adminToken: currentToken,
        });
        window.location.href = '/dashboard';
      },
      stopImpersonating: () => {
        const adminToken = get().adminToken || localStorage.getItem('admin_token');
        if (!adminToken) return;
        localStorage.setItem('token', adminToken);
        localStorage.removeItem('admin_token');
        set({ token: adminToken, impersonating: null, adminToken: null, role: 'admin' });
        window.location.href = '/admin/usuarios';
      },
      logout: () => {
        localStorage.removeItem('token');
        set({ user: null, token: null, role: 'sender' });
      },

      fetchMe: async () => {
        const res = await authAPI.me();
        set({ user: res.data, role: res.data.role });
      },
    }),
    { name: 'remesas-auth', partialize: (s) => ({ token: s.token, role: s.role }) }
  )
);

// ── UI STORE ────────────────────────────────────────────────────────────────
export const useUIStore = create((set) => ({
  sendModalOpen: false,
  txDetailRef: null,

  openSendModal: () => set({ sendModalOpen: true }),
  closeSendModal: () => set({ sendModalOpen: false }),
  openTxDetail: (ref) => set({ txDetailRef: ref }),
  closeTxDetail: () => set({ txDetailRef: null }),
}));

// ── TRANSACTIONS STORE ──────────────────────────────────────────────────────
export const useTxStore = create((set, get) => ({
  transactions: [],
  loading: false,
  error: null,

  fetch: async (params = {}) => {
    set({ loading: true, error: null });
    try {
      const { txAPI } = await import('../services/api');
      const res = await txAPI.list(params);
      set({ transactions: res.data, loading: false });
    } catch (e) {
      set({ error: e.message, loading: false });
    }
  },

  create: async (data) => {
    const { txAPI } = await import('../services/api');
    const res = await txAPI.create(data);
    set((s) => ({ transactions: [res.data, ...s.transactions] }));
    return res.data;
  },
}));
